import { createFileRoute } from "@tanstack/react-router";

import { CalendarPage } from "../calendar/calendar-page.tsx";
import { loadCalendar } from "../calendar/loaders.ts";
import { CalendarPending } from "../calendar/pending.tsx";
import { loadInPlace } from "../data/ensure.ts";
import { useViewer } from "../data/hooks.ts";
import { calendarSearch, retainPropertyFilter } from "../shell/search.ts";
import { NoAccessPage } from "../shell/status-pages.tsx";

import type { ReactElement } from "react";

const Page = (): ReactElement => {
  const viewer = useViewer();
  return viewer === null ? <NoAccessPage /> : <CalendarPage viewer={viewer} />;
};

// WHY: the period title is the page title, so the top bar shows none (13-calendar).
export const Route = createFileRoute("/_app/calendar/")({
  staticData: { hasPropertyContext: true },
  validateSearch: calendarSearch,
  search: retainPropertyFilter(),
  loader: async ({ context, location, cause }) =>
    loadInPlace(cause, async () => loadCalendar(context.data, calendarSearch.parse(location.search))),
  pendingComponent: CalendarPending,
  component: Page,
});
